import { useState } from 'react'
import styled from 'styled-components'
import { colors } from '../../Global/Styles/variables'
import {
  useGlobalState,
  setSelectedRoleToLocalStore,
} from '../../Global/GlobalContext'
import { Roles } from 'src/types/enums'
import { Button } from '@truepill/react-capsule'
import { RedirectToAfterRoleSelection } from 'src/Global/Router'
import { isMedOps } from 'src/Global/Utils'

export interface SelectRoleProps {
  onCancel: () => void
  cancelButtonText?: string
  confirmButtonText?: string
}

const capitalize = (text: string) => {
  if (typeof text !== 'string') return ''
  return text.charAt(0).toUpperCase() + text.slice(1)
}

const SelectRole = ({
  onCancel = () => {},
  cancelButtonText = 'Back',
  confirmButtonText = 'Sign In',
}: SelectRoleProps) => {
  const globalState = useGlobalState()
  const { authorization, setEMRAuthState, whoAmI } = globalState
  const [selectedRole, setSelectedRole] = useState(whoAmI)

  const onSelectRole = (role: Roles) => {
    setSelectedRole(role)
  }

  const handlerConfirm = () => {
    setSelectedRoleToLocalStore(selectedRole as Roles)
    setEMRAuthState({
      ...globalState,
      whoAmI: selectedRole as Roles,
      redirectToAfterRoleSelection: RedirectToAfterRoleSelection.MAIN,
    })
  }

  const getRadioButton = (role: string) => (
    <RadioButtonContainer key={`${role}-radio-container`}>
      <RadioButton
        data-testid={`${role}-radio`}
        type="radio"
        id={`${role}-radio`}
        name={role}
        checked={selectedRole === role}
        onChange={() => onSelectRole(role as Roles)}
      />
      <Label htmlFor={`${role}-radio`}>{capitalize(role)}</Label>
    </RadioButtonContainer>
  )

  return (
    <Container data-testid="select-role">
      <OptionsContainer>
        {authorization?.userRoles?.map((role) => getRadioButton(role))}
      </OptionsContainer>
      <ButtonsContainer>
        <SyledButton variant="primary-text" onClick={onCancel}>
          {cancelButtonText}
        </SyledButton>
        <SyledButton
          variant="primary"
          onClick={() => handlerConfirm()}
          disabled={!selectedRole}
        >
          {confirmButtonText}
        </SyledButton>
      </ButtonsContainer>
    </Container>
  )
}

const Container = styled.div`
  width: 100%;
`

const SyledButton = styled(Button)`
  font-weight: 700;!important
`

const ButtonsContainer = styled.div`
  margin-top: 40px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
`

const Label = styled.label`
  color: ${colors.blackPearl};
  font-size: 1rem;
`

const RadioButton = styled.input`
  appearance: radio;
  margin: 0.625rem 0.625rem 0 0;
`

const RadioButtonContainer = styled.div`
  appearance: radio;
`

const OptionsContainer = styled.div`
  margin-top: 1.25rem;
`

export default SelectRole
